import { useEffect, useState } from "react";
import * as LiveSessionStates from "../constants/liveSessionStates";
import * as UserRoles from "../constants/roles";
import { getChannelOccupancy } from "../utils/webSocket";

export const useLiveSessionWSStateChange = ({
  userRole,
  isWebSocketConnected,
  webSocketConfig,
} = {}) => {
  const [isSessionStreamingWSEvent, setSessionStreamingWSEvent] = useState();
  const [isSessionFinishedWSEvent, setSessionFinishedWSEvent] = useState();
  const [isSessionCancelledWSEvent, setSessionCancelledWSEvent] = useState();
  const [stateChangeOccupancy, setStateChangeOccupancy] = useState(0);
  const [stateChangeWSConfig, setStateChangeWSConfig] = useState();

  const setupStateChangeWS = () => {
    const lsStateChangeChannel = webSocketConfig.stateChannel.channelName;
    const lsStateChangePresenceChannel = webSocketConfig.stateChannel.presenceChannelName;

    const stateChangeEvent = {
      [UserRoles.STUDENT]: {
        [LiveSessionStates.STREAMING]: () => setSessionStreamingWSEvent(true),
        [LiveSessionStates.FINISHED]: () => setSessionFinishedWSEvent(true),
        [LiveSessionStates.CANCELLED]: () => setSessionCancelledWSEvent(true),
      },
      [UserRoles.TEACHER]: {
        [LiveSessionStates.FINISHED]: () => setSessionFinishedWSEvent(true),
        [LiveSessionStates.CANCELLED]: () => setSessionCancelledWSEvent(true),
      },
    };

    return {
      channels: [
        {
          channelName: lsStateChangeChannel,
          withPresence: true,
        },
      ],
      messagesListener: {
        [lsStateChangeChannel]: ({ message } = {}) =>
          stateChangeEvent[userRole][message?.state]?.(),
      },
      presenceListener: {
        [lsStateChangePresenceChannel]: ({ occupancy } = {}) => {
          setStateChangeOccupancy(occupancy);
        },
      },
    };
  };

  const subscribeStateChange = async () => {
    const { channels, messagesListener, presenceListener } = setupStateChangeWS();
    setStateChangeWSConfig({
      channels,
      messagesListener,
      presenceListener,
    });
  };

  const getStateChangeOccupancy = async () => {
    const stateChannelOccupancyResponse = await getChannelOccupancy({
      channelName: webSocketConfig.stateChannel.channelName,
    });

    if (stateChannelOccupancyResponse?.totalOccupancy) {
      setStateChangeOccupancy(stateChannelOccupancyResponse?.totalOccupancy);
    }
  };

  useEffect(() => {
    if (isWebSocketConnected) {
      subscribeStateChange();
    }
  }, [isWebSocketConnected]);

  useEffect(() => {
    if (stateChangeWSConfig) {
      getStateChangeOccupancy();
    }
  }, [stateChangeWSConfig]);

  return {
    isSessionStreamingWSEvent,
    isSessionFinishedWSEvent,
    isSessionCancelledWSEvent,
    stateChangeOccupancy,
    stateChangeWSConfig,
  };
};
